module.exports = __webpack_public_path__ + "static/frontUserNew/img/inner-list03.f4f9ce43.png";